module.exports = __webpack_public_path__ + "static/media/robots.be20aebe.txt";